import { render, staticRenderFns } from "./BaseCombo.vue?vue&type=template&id=05a1ecc8&scoped=true"
import script from "./BaseCombo.vue?vue&type=script&lang=js"
export * from "./BaseCombo.vue?vue&type=script&lang=js"
import style0 from "./BaseCombo.vue?vue&type=style&index=0&id=05a1ecc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a1ecc8",
  null
  
)

export default component.exports